// `403 insufficient_role` (`spec/17-frontend.md` §4.3): a tela é esta, com logout.
// **Nunca** `/login`, o seller que caiu no host de admin entraria em laço.

import { useMutation, useQueryClient } from '@tanstack/react-query';
import { createFileRoute } from '@tanstack/react-router';
import { signOut } from '../api/auth.ts';
import { LogoMark } from '../components/app/brand.tsx';
import { Button } from '../components/ui/button.tsx';

function NoAccess() {
  const queryClient = useQueryClient();
  const leave = useMutation({
    mutationFn: signOut,
    onSettled: () => {
      queryClient.clear();
      window.location.assign('/login');
    },
  });

  return (
    <main className="grid min-h-dvh place-items-center p-6">
      <div className="flex max-w-md flex-col items-center gap-4 text-center">
        <LogoMark size={48} />
        <h1 className="text-22 font-semibold">Sem acesso a esta superfície</h1>
        <p className="text-14 text-muted">
          Esta conta não tem permissão para o painel deste endereço. Saia e entre com a conta certa.
        </p>
        <Button
          onClick={() => {
            leave.mutate();
          }}
          disabled={leave.isPending}
        >
          {leave.isPending ? 'Saindo…' : 'Sair'}
        </Button>
      </div>
    </main>
  );
}

export const Route = createFileRoute('/no-access/')({ component: NoAccess });
